var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSbpColorable = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 21 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.666 4.677v2.934H19.62V5.553h-1.01v2.058h-1.047V4.677z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.411 7.716c.938 0 1.634-.575 1.634-1.447 0-.843-.514-1.391-1.372-1.391-.397 0-.724.14-.97.38a.97.97 0 0 1 .943-.86l.912-.002.455-.871s-1.01.023-1.48.023c-1.074.019-1.799.994-1.799 2.179 0 1.38.707 1.99 1.677 1.99m.006-2.067c.348 0 .59.23.59.62 0 .353-.215.643-.59.643-.36 0-.6-.268-.6-.637 0-.39.24-.626.6-.626",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.88 6.63s-.25.14-.62.17c-.42.01-.8-.26-.8-.73 0-.46.34-.73.79-.73.28 0 .65.2.65.2s.27-.5.41-.75c-.26-.19-.6-.3-1-.3-1.01 0-1.79.66-1.79 1.58 0 .94.74 1.58 1.79 1.56.3-.01.7-.11.95-.27zM0 2.61l1.45 2.6v1.58L0 9.39zm5.58 1.65 1.36-.83h2.79L5.58 5.97zM5.57 2.6l.01 3.44-1.46-.89V0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.73 3.43H6.94L5.57 2.6 4.12 0zM5.58 9.4V7.73l-1.46-.88V12z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.94 8.57 1.45 5.21 0 2.61l9.72 5.96zM4.12 12l1.46-2.6 1.36-.83h2.78z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m.002 9.386 4.133-2.532-1.39-.852-1.292.792z"
})));
export default SvgSbpColorable;